module.exports = __webpack_public_path__ + "static/media/Waiting_Room.a636a4e3.svg";